import { FC, useMemo } from 'react';
import { Card } from '@/components/ui/card';
import { SectionHeadingGroup } from '@/components/ui/section-heading-group';
import { strings } from '@/constants/strings';
import { useCurrentNotificationResponses } from '@/hooks/use-current-notification-responses';
import { useCurrentWellbeingResponses } from '@/hooks/use-current-welbeing-responses';
import { toSorted } from '@/utils/array/to-sorted';
import { compareWellbeingResponsesByTimeDesc } from '@/utils/wellbeing-response/compare-wellbeing-responses-by-time-desc';
import { ResponseList } from './components/response-list';

export const WellbeingResponsesView: FC = () => {
  const { data: Responses, isFetching: isFetchingResponses } =
    useCurrentWellbeingResponses();

  const orderedResponses = useMemo(
    () => toSorted(Responses, compareWellbeingResponsesByTimeDesc),
    [Responses],
  );

  return (
    <>
      {/* TODO extract row layout into reusable component i.e. shared with unit creation steps */}
      <div className="flex flex-row flex-wrap gap-8">
        <div className="w-min min-w-60 max-w-96 flex-grow">
          {/* TODO: use SectionContainerLayout */}
          <SectionHeadingGroup
            subtitle={strings.wellbeing_responses.subtitle}
            title={strings.wellbeing_responses.title}
          />
        </div>
        <Card className="w-min min-w-[32rem] p-6">
          <div className="pb-7 pl-6 pt-1">
            <div className="text-base font-semibold">Last 30 days</div>
          </div>
          <ResponseList
            loading={isFetchingResponses}
            responses={orderedResponses}
          />
        </Card>
      </div>
    </>
  );
};

export const NotificationResponsesView: FC = () => {
  const { data: Responses, isLoading: isLoadingResponses } =
    useCurrentNotificationResponses();

  const orderedResponses = useMemo(
    () => toSorted(Responses, compareWellbeingResponsesByTimeDesc),
    [Responses],
  );

  return (
    <>
      {/* TODO extract row layout into reusable component i.e. shared with unit creation steps */}
      <div className="flex flex-row flex-wrap gap-8">
        <div className="w-min min-w-60 max-w-96 flex-grow">
          {/* TODO: use SectionContainerLayout */}
          <SectionHeadingGroup
            subtitle={strings.notification_responses.subtitle}
            title={strings.notification_responses.title}
          />
        </div>
        <Card className="w-min min-w-[32rem] p-6">
          <div className="pb-7 pl-6 pt-1">
            <div className="text-base font-semibold">Last 30 days</div>
          </div>
          <ResponseList
            loading={isLoadingResponses}
            responses={orderedResponses}
          />
        </Card>
      </div>
    </>
  );
};
